var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoRename = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.15,
    height: 14,
    viewBox: "0 0 14.15 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_Rename",
    transform: "translate(-514.85 -297.213)",
    stroke: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_47558",
    "data-name": "Path 47558",
    d: "M7.735-4.37H2.892L1.8-1.636H.232l4.414-10.45H5.98L10.4-1.636H8.839ZM3.353-5.5h3.93L5.314-10.385Z",
    transform: "translate(514.768 310.605)",
    fill: "#999",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28687",
    "data-name": "Group 28687",
    transform: "translate(525 297.213)",
    fill: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_13115",
    "data-name": "Rectangle 13115",
    transform: "translate(1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 1,
    height: 13,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_13116",
    "data-name": "Rectangle 13116",
    transform: "rotate(-90 .5 .5)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 4,
    rx: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    height: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_13117",
    "data-name": "Rectangle 13117",
    transform: "rotate(-90 7 7)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 4,
    rx: 0.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    height: 3,
    fill: "none"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoRename);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_rename.3f6b8fb0f0ab27f61c0be653166a8791.svg";